<template>
  <div class="w-full bg-white md:rounded-[20px] sm:p-6 md:p-8 lg:p-10 flex  shadow-sm">
    <div class="relative flex flex-col lg:flex-row md:gap-4 lg:gap-10 w-full">
      <!-- Image with fixed size (no resize) -->
      <img
        class="lg:w-[250px] lg:h-[250px] md:rounded-2xl mb-4 sm:mb-0"
        :src="img"
        alt="Sub Services"
      />

      <!-- Content Section -->
      <div class="lg:w-[820px] lg:h-[222px] lg:gap-[20px] gap-4 flex flex-col">
        <!-- Title -->
        <h1
          class="text-[20px] md:text-[24px] lg:text-[30px] font-bold leading-tight"
        >
          {{ title }}
        </h1>

        <!-- Description -->
        <p class="text-[16px] lg:text-[20px] leading-relaxed sm:leading-normal">
          {{ description }}
        </p>
      </div>

      <!-- <div class="absolute bottom-0 right-0">
        <img :src="Button" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
import Button from "@/assets/pictures/Button.svg";
export default {
  props: {
    img: { String, required: true },
    title: { String, required: true },
    description: { String, required: true },
  },
  data() {
    return {
      Button: Button,
    };
  },
};
</script>

<style scoped></style>
